import { render, staticRenderFns } from "./shareExportFooter.vue?vue&type=template&id=74da8648"
import script from "./shareExportFooter.vue?vue&type=script&lang=js"
export * from "./shareExportFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports